import { Component } from '@angular/core';
import { ProductTranslation } from '@common/util/static-entities/product';
import { ProductId } from '@common/util/static-entities/product-id';
import { AppSwitcherService } from './app-switcher.service';
@Component({
    selector: 'app-switcher',
    templateUrl: './app-switcher.component.html',
    styleUrls: ['./app-switcher.component.scss'],
    providers: [AppSwitcherService],
    standalone: false
})
export class AppSwitcherComponent {
  ProductTranslation = ProductTranslation;
  ProductId = ProductId;

  constructor(public srv: AppSwitcherService) {}
}
